"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genYupValidatorBySchema = exports.validationName = exports.isEmail = exports.isRequired = void 0;
var genYupValidatorBySchema_1 = __importDefault(require("./genYupValidatorBySchema"));
var isRequired = function (string) {
    if (string.length === 0) {
        return false;
    }
    return true;
};
exports.isRequired = isRequired;
var isEmail = function (email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
};
exports.isEmail = isEmail;
exports.validationName = {
    required: 'required',
    email: 'email',
};
exports.genYupValidatorBySchema = genYupValidatorBySchema_1.default;
